exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-sm[data-v-15436aa2],\n.btn-group-sm > .btn[data-v-15436aa2] {\n  line-height: 1px;\n}\n.border-dashed[data-v-15436aa2] {\n  border: 1px dashed #f5f5f5;\n  border-radius: 7px;\n}\n.bg-lighter[data-v-15436aa2] {\n  background: #f5f5f5;\n}\n", ""]);

// exports
